import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 판매 금액 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('|'))

import {computed, toRefs} from 'vue'
import {prettyDateToOnemonth, numberToKorean, currency, only3} from '@/utils/filters'
import {AgBoxS, AgIconS} from '@/components/ag'

export default /*#__PURE__*/_defineComponent({
  props: {
  author: {type: String},
  createAt: {type: String},
  id: {type: String},
  isLike: {default: false, type: Boolean},
  isLogin: {default: false, type: Boolean},
  kind: {type: String},
  likeCount: {default: 0, type: Number},
  messageCount: {default: 0, type: Number},
  name: {type: String},
  pricePerStock: {default: 0, type: Number},
  stockCount: {default: 0, type: Number},
  totalStockCount: {default: 0, type: Number},
},
  emits: ['like', 'open'],
  setup(__props, { emit: emits }) {

const props = __props





const {totalStockCount, pricePerStock, stockCount, createAt, id, kind, name, author} = toRefs(props)
const marketCap = computed(() => {
  return numberToKorean(totalStockCount.value * pricePerStock.value)
})
const totalPrice = computed(() => {
  return currency(stockCount?.value * pricePerStock?.value)
})
const createAge = computed(() => {
  return prettyDateToOnemonth(createAt?.value)
})
const maskedAuthor = computed(() => {
  return only3(author?.value)
})
const maskedPricePerStock = computed(() => {
  return currency(pricePerStock?.value)
})


const onLike = () => {
  emits('like', {id: id?.value, kind: kind?.value, name: name?.value})
}

const onOpen = () => {
  emits('open', {id: id?.value, name: name?.value})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), {
    css: {corner: 10, border: '1px solid #EEF1F7', bg: 'white', p: 16, mb: 2, justifyContent: 'stretch'},
    onClick: onOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row', alignItems: 'center', mb: 2} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {color: 'gray3', typography: 'main13r', grow: 1} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          (__props.isLogin)
            ? (_openBlock(), _createBlock(_unref(AgBoxS), {
                key: 0,
                css: {dp: 'flex', direction: 'row'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), { css: {typography: 'num16eb', mr: 4} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(maskedPricePerStock)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgBoxS), { css: {typography: 'main16r'} }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(AgBoxS), {
                key: 1,
                css: {color: 'gray3', typography: 'main16r'}
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row', justifyContent: 'flex-end', mb: 2} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {corner: 4, bg: 'bg1', dp: 'flex', direction: 'row', alignItems: 'center', px: 8, py: 4} }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgIconS), {
                name: "businessOutline",
                css: {width: 12, height: 12, color: 'gray3', mr: 4, shrink: 0}
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'main12r', color: 'gray3', whiteSpace: 'nowrap'} }, {
                default: _withCtx(() => [
                  _createTextVNode(" 시총 " + _toDisplayString(__props.isLogin ? _unref(marketCap) : '?') + "원 상당 ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row', mb: 10} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {color: 'gray3', typography: 'main13r', grow: 1} }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main13r', color: 'font', mr: 4} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.isLogin ? _unref(stockCount) : '?') + " 주 ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main13r', color: 'gray3'} }, {
            default: _withCtx(() => [
              _createTextVNode(" (총 " + _toDisplayString(_unref(totalPrice)) + " 원) ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row', alignItems: 'center'} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgIconS), {
            name: "personCircleOutline",
            css: {color: 'gray5', width: 20, height: 20, mr: 2, shrink: 0}
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main13r', color: 'gray3', mr: 4, shrink: 0} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(maskedAuthor)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {color: 'bg2', typography: 'main12r', mr: 4, shrink: 0} }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main13r', color: 'gray3', mr: 4, shrink: 0} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(createAge)) + " 등록 ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), {
            css: {grow: 1, justifyContent: 'flex-end', dp: 'flex', direction: 'row'},
            onClick: _withModifiers(onLike, ["stop"])
          }, {
            default: _withCtx(() => [
              (__props.isLike)
                ? (_openBlock(), _createBlock(_unref(AgIconS), {
                    key: 0,
                    name: "heart",
                    css: {width: 24, height: 24, color: 'blue1', mr: 4}
                  }))
                : (_openBlock(), _createBlock(_unref(AgIconS), {
                    key: 1,
                    name: "heart",
                    css: {width: 24, height: 24, color: 'gray6', mr: 4}
                  })),
              _createVNode(_unref(AgBoxS), { css: {typography: 'main12r', color: 'gray3', grow: 1} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.likeCount), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})